import type { JSX } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { JobPositionFormFields } from './JobPositionFormFields';
import { useCreateJobPositionForm } from './CreateJobPositionDialog.hooks';

interface CreateJobPositionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function FormFooter({
  isLoading,
  onCancel,
}: {
  isLoading: boolean;
  onCancel: () => void;
}): React.JSX.Element {
  return (
    <DialogFooter>
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="submit" disabled={isLoading}>
        {isLoading ? 'Creating...' : 'Create'}
      </Button>
    </DialogFooter>
  );
}

export function CreateJobPositionDialog({
  open,
  onOpenChange,
}: CreateJobPositionDialogProps): JSX.Element {
  const form = useCreateJobPositionForm(onOpenChange);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[90vh] overflow-y-auto sm:max-w-[700px]"
        data-row-click-ignore
      >
        <DialogHeader>
          <DialogTitle>Create Job Position</DialogTitle>
        </DialogHeader>
        <form onSubmit={form.onSubmit} className="space-y-4">
          <JobPositionFormFields
            register={form.register}
            errors={form.errors}
            setValue={form.setValue}
            watch={form.watch}
          />
          <FormFooter isLoading={form.isLoading} onCancel={() => onOpenChange(false)} />
        </form>
      </DialogContent>
    </Dialog>
  );
}
